import { Component } from 'react';
import { connect } from 'react-redux';
import { withMsal } from '@azure/msal-react';
import { EventType, InteractionType } from '@azure/msal-browser';
import { Redirect, withRouter } from 'react-router-dom';
import { detect } from 'detect-browser';
import msalInstance from './services/msal/msal';
import { addMessage } from './store/ancillary/actions';
import WithLegacyApp from './hoc/WithLegacyApp/WithLegacyApp';
import MainLayout from 'components/layouts/MainLayout';
import Snackbar from '@mui/material/Snackbar';
import Routes from './routes/Routes';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import './App.css';

/**
 * App class component:  primary mounting point for index.js
 */
class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isSnackbarOpen: false,
			redirectURL: '',
		};

		// attach event callback for token acquisition redirects when session still valid
		msalInstance.addEventCallback(event => {
			switch (event.eventType) {
				// returning to site
				case EventType.ACQUIRE_TOKEN_SUCCESS:
					if (event.interactionType === InteractionType.Redirect) {
						this.props.addMessage({
							Key: 1,
							Value: 'You have been re-authenticated.',
						});
						this.setState({ isSnackbarOpen: true });
					}
					break;
				default:
					break;
			}
		});
	}

	/**
	 * componentDidMount()
	 * check for browser and display messages for unsupported
	 * retrieve the Tracking Number from the query params
	 */
	async componentDidMount() {
		this.detectUnsupportedBrowser();
	}

	/**
	 * detectUnsupportedBrowser
	 * Check which browser the user is using to access IMS.  If unsupported, dispatch message to switch to other browser
	 */
	detectUnsupportedBrowser = () => {
		const browser = detect();
		let message = null;
		switch (browser && browser.name) {
			case 'chrome':
			case 'edge-chromium':
				break;
			case 'firefox':
				message =
					'You are currently using IMS on Mozilla Firefox.  IMS is supported on Microsoft Edge and Google Chrome.  Please switch to one of these supported browsers.';
				break;
			case 'ie':
				message =
					'You are currently using IMS on Internet Explorer.  IMS is supported on Microsoft Edge and Google Chrome.  Please switch to one of these supported browsers.';
				break;
			default:
				message =
					'You are currently using IMS on an unknown browser.  IMS is supported on Microsoft Edge, Google Chrome, and Mozilla Firefox.  Please switch to one of these supported browsers.';
		}
		if (message && message.length > 0) {
			this.props.addMessage({ Key: 2, Value: message });
		}
	};

	onSnackBarCloseHandler = reason => {
		switch (reason) {
			case 'timeout':
				this.setState({
					isSnackbarOpen: false,
					redirectURL: '/index.html',
				});
				break;
			default:
				break;
		}
	};

	/**
	 * render()
	 * render the component
	 */
	render() {
		return (
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<MainLayout>
					<WithLegacyApp>
						<Routes />
						<Snackbar
							open={this.state.isSnackbarOpen}
							message={'Redirecting home...'}
							autoHideDuration={4000}
							onClose={(_, reason) =>
								this.onSnackBarCloseHandler(reason)
							}
						/>
						{this.state.redirectURL && (
							<Redirect to={this.state.redirectURL} />
						)}
					</WithLegacyApp>
				</MainLayout>
			</LocalizationProvider>
		);
	}
}

/**
 * mapDispatchToProps
 * map action-dispatch methods to local props methods
 * @param {*} dispatch
 * dispatch:  represents the dispatch method defined in the actions
 */
const mapDispatchToProps = dispatch => {
	return {
		addMessage: message => dispatch(addMessage(message)),
	};
};

/**
 * Export App component
 */
export default withMsal(connect(null, mapDispatchToProps)(withRouter(App)));
